import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useEffect, useMemo } from 'react';

import { bimWorkOrderChangeLastSeasonSelectionListGql } from '../bimWorkOrderChangeStructureQueries';

const requestId = 'useBimWorkOrderChangeLastSeasonSelectionList';

export const useBimWorkOrderChangeLastSeasonSelectionList = (workOrderChangeId: number, withEffect?: boolean) => {
    const variables = useMemo(() => ({ workOrderChangeId }), [workOrderChangeId]);

    const [data] = useRequest({
        requestId,
        query: bimWorkOrderChangeLastSeasonSelectionListGql,
        withEffect: withEffect ?? !!workOrderChangeId,
        variables,
    });

    const [reset] = useResetStoreData({
        requestId,
    });

    useEffect(
        () => () => {
            reset(undefined);
        },
        [reset],
    );

    return {
        seasonSelectionList: data?.bimWorkOrderChangeLastSeasonSelectionList ?? [],
    };
};
